// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Login',
  subtitle: 'Welcome to Domain Control Panel',
  username: 'Username',
  password: 'Password',
  rememberMe: 'Remember Me',
  loginButton: 'Login',
  loginError: 'Invalid username or password',
  usernameRequired: 'Username is required',
  passwordRequired: 'Password is required',
  loggingIn: 'Logging in...'
};
